import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LoggingService, MemberQuery, NotificationCenterService, Population, PopulationQuery, SignalRHub } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { NavigationService, NavigationSettings } from '@fgb/portal-component-library/src/lib/shared/services';
import { combineLatest, Subscription } from 'rxjs';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-master-page',
  templateUrl: './master-page.component.html',
  styleUrls: ['./master-page.component.scss'],
})
export class MasterPageComponent implements OnInit {
  private _destroyRef = inject(DestroyRef);
  screenType = ScreenType;
  navigationSettings: NavigationSettings;
  observable$: Subscription;
  populations = Populations;
  population: Population | undefined;
  populationID: string | undefined;

  constructor(
    private signalRHub: SignalRHub,
    private logService: LoggingService,
    private notificationCenterService: NotificationCenterService,
    private navigationService: NavigationService,
    private populationQuery: PopulationQuery,
    private memberQuery: MemberQuery
  ) {}

  ngOnInit() {
    this.signalRHub.connectionEstablished$.pipe(takeUntilDestroyed(this._destroyRef)).subscribe((connection) => {
      this.logService.debug('SignalR connection', connection);
    });
    this.notificationCenterService.fetchNotificationCenter(5).pipe(takeUntilDestroyed(this._destroyRef)).subscribe();

    // Subscribe to navigation changes
    this.navigationService.onNavigationChanged.pipe(takeUntilDestroyed(this._destroyRef)).subscribe((navigationSettings) => {
      this.navigationSettings = navigationSettings;
    });

    this.population = this.populationQuery.getCurrentPopulation();

    this.observable$ = combineLatest([this.signalRHub.connectionEstablished$, this.memberQuery.userContext$]).subscribe(
      ([connection, memberDetail]) => {
        this.logService.debug('SignalR connection', connection);
        this.populationID = memberDetail?.populationId;
        document.body.classList.add(`PopId-${this.populationID}`);
      }
    );
  }
}
